export const FETCH_ALL = "FETCH_ALL";
export const FETCH_POST = "FETCH_POST";
export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE ="DELETE";
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH';
export const END_LOADING = 'END_LOADING';
export const START_LOADING = 'START_LOADING';
export const COMMENT = 'COMMENT';
export const FETCH_USERS_POSTS = 'FETCH_USERS_POSTS';
export const CLEAR_POST = 'CLEAR_POST';
export const IS_FETCHING = 'IS_FETCHING';

export const AUTH ="AUTH";
export const LOGOUT ="LOGOUT";
export const UPDATE_USER = "UPDATE_USER";
export const RECOVER_USER = "RECOVER_USER";
export const ERROR = "ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const SET_USERS = "SET_USERS";
export const SET_USER = "SET_USER";
export const SET_AUTORS = "SET_AUTORS";
export const CLEAN_AUTHORS = "CLEAN_AUTHORS";
export const NOT_AUTHOR = "NOT_AUTHOR";
export const CLEAN_NO_AUTHOR = "CLEAN_NO_AUTHOR";
export const SEARCHING = "SEARCHING";



